import { DocumentPostRequestBody, DocumentPostResponse } from '@lio/api-types';
import { documentQueryKey } from '@services/document/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateDocument = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (body: DocumentPostRequestBody) =>
      client
        .post('document', {
          json: {
            ...body,
          },
        })
        .json<DocumentPostResponse>(),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: documentQueryKey.search });
      queryClient.invalidateQueries({ queryKey: ['subjectivities'] });
      if (variables.policyId) {
        queryClient.invalidateQueries({ queryKey: ['policy', variables.policyId, 'document-archive'] });
      }
    },
  });
  return { ...result, createDocumentAsync: result.mutateAsync };
};
